export default {
    PtImagePanel: {
        page: '整页浏览',
        image: '单图浏览',
    },
};
